"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let CopyBillingListItems = class CopyBillingListItems extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
        this.$$cache_selectedMode = new core_1.ComponentValueCache(this, "selectedMode", "CopyBillingListItems.selectedMode");
    }
    getItem(...args) {
        const [sources, fields] = args;
        const fieldNames = _.map(fields, 'name');
        let result = _.reduce(fieldNames, (m, v) => _.set(m, v, null), {});
        result['$updates'] = _.reduce(fieldNames, (m, v) => _.set(m, v, false), {});
        return result;
    }
    getPayload(...args) {
        const [sources, item] = args;
        const updates = _.intersection(_.keys(_.pickBy(item.$updates, _.identity)), this.getVisibleFields());
        if (!updates.length) {
            return;
        }
        return { ..._.pick(item, updates), sources };
    }
    onProductSelected(...args) {
        const [data] = args;
        if (!data.name) {
            return;
        }
        this.item.description = data.name;
        this.item.$updates['description'] = true;
        this.item.unit = data.unit;
        this.item.$updates['unit'] = true;
    }
    getVisibleFields(...args) {
        const selectedMode = this.selectedMode;
        return _
            .chain(this.fields)
            .filter(field => !_.isArray(field.mode) || field.mode.indexOf(selectedMode) > -1)
            .map('name')
            .value();
    }
    isFieldVisible(...args) {
        const [name] = args;
        const mode = _.get(this.fieldsByName[name], 'mode');
        if (_.isArray(mode)) {
            return mode.indexOf(this.selectedMode) > -1;
        }
        return true;
    }
    sources;
    onSources(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("sources");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    isReadonly;
    formModes;
    selectedMode;
    fields;
    fieldsByName;
    async $$load_fieldsByName() {
        return _.keyBy(this.$data.fields, 'name');
    }
    labelAlign;
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    formName;
    item;
    async $$load_item() {
        return this.getItem(this.sources, this.$data.fields);
    }
    ux;
    b_7315092382398562_modalBindings;
    b_814138253067422_dataSource;
    dataMembers = ['isReadonly', 'formModes', 'selectedMode', 'fields', 'fieldsByName', 'labelAlign', 'formId', 'formName', 'item', 'ux', 'b_7315092382398562_modalBindings', 'b_814138253067422_dataSource'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                isReadonly: false,
                formModes: [{
                        value: "discount",
                        name: this.$fn.pgettext("CopyBillingListItems", "Simple discount"),
                    },
                    {
                        value: "complex",
                        name: this.$fn.pgettext("CopyBillingListItems", "Complex calculations"),
                    },
                ],
                selectedMode: "discount",
                fields: [{
                        name: "product",
                        help: this.$fn.pgettext("CopyBillingListItems", "Override the product or service reference for this line."),
                    },
                    {
                        name: "description",
                        help: this.$fn.pgettext("CopyBillingListItems", "Override the line description with any freeform text."),
                    },
                    {
                        name: "intermediated_service",
                        help: this.$fn.pgettext("CopyBillingListItems", "Set or override whether this line represents an intermediated service."),
                    },
                    {
                        name: "unit",
                        help: this.$fn.pgettext("CopyBillingListItems", "The unit to use to generate the new items."),
                        mode: ["discount",
                            "complex",
                        ],
                    },
                    {
                        name: "quantity",
                        help: this.$fn.pgettext("CopyBillingListItems", "Define a fixed quantity to use when generating the new items."),
                        mode: ["complex",
                        ],
                    },
                    {
                        name: "quantity_percentage",
                        help: "P_(\"CopyBillingListItems\", \"Specify the quantity as a percentage of the original item’s quantity.\")",
                        mode: ["complex",
                        ],
                    },
                    {
                        name: "price",
                        help: this.$fn.pgettext("CopyBillingListItems", "Set a fixed price to apply to the new items, overriding the original price."),
                        mode: ["complex",
                        ],
                    },
                    {
                        name: "price_percentage",
                        help: "P_(\"CopyBillingListItems\", \"Set the price as a percentage of the original item’s price.\")",
                        mode: ["complex",
                        ],
                    },
                    {
                        name: "discount_percentage",
                        help: this.$fn.pgettext("CopyBillingListItems", "Apply a discount percentage to the new items."),
                        mode: ["discount",
                        ],
                    },
                    {
                        name: "notes",
                        help: this.$fn.pgettext("CopyBillingListItems", "Add or override the internal notes for the generated invoice line."),
                    },
                ],
                fieldsByName: null,
                labelAlign: "right",
                formId: null,
                formName: "CopyBillingListItems",
                item: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "lg",
                },
                b_814138253067422_dataSource: {
                    name: "suggest_product",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.pgettext("CopyBillingListItems|Title", "Copy Billing List Items"),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_2156_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_closeComponent_2162_getActionArgs($event) {
        return {
            result: {
                ok: true,
                value: $event.data.response.data,
            },
        };
    }
    async act_1040167445267876_request_2160_getActionArgs($event) {
        return {
            operation: "copy_billing_list_items",
            data: this.getPayload(this.sources, this.item),
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async act_814138253067422_script_2164_getActionArgs_value($event) {
        this.onProductSelected($event.data.option);
    }
    async act_814138253067422_script_2164_getActionArgs($event) {
        return {
            value: () => this.act_814138253067422_script_2164_getActionArgs_value($event),
        };
    }
    async evh_814138253067422_optionSelected(event, scope) {
        return await this.actions.evh_814138253067422_optionSelected.executeFromDOM(this, event, scope);
    }
    async evh_1419464017721962_clickPreventStop(event, scope) {
        return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_2156 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_2156_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_2155 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_2156,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_2155],
        });
        const act_2248226175642056_closeComponent_2158 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_2157 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_2158,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_2157],
        });
        const act_1040167445267876_closeComponent_2162 = new core_1.actions.CloseComponentAction({
            actionArgs: this.act_1040167445267876_closeComponent_2162_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_2161 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeComponent_2162,
            event: "success",
            displayName: "closeComponent",
        });
        const act_1040167445267876_request_2160 = new core_1.actions.RequestAction({
            actionArgs: this.act_1040167445267876_request_2160_getActionArgs,
            displayName: "save",
            events: [evh_1040167445267876_success_2161],
        });
        const evh_1040167445267876_submit_2159 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_request_2160,
            event: "submit",
            displayName: "save",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_2159],
        });
        const act_814138253067422_script_2164 = new core_1.actions.ScriptAction({
            actionArgs: this.act_814138253067422_script_2164_getActionArgs,
            events: [],
        });
        const evh_814138253067422_optionSelected_2163 = new core_1.actions.EventHandlerImpl({
            action: act_814138253067422_script_2164,
            event: "optionSelected",
            displayName: "script",
        });
        const evh_814138253067422_optionSelected = new core_1.actions.EventHandlerGroup({
            handlers: [evh_814138253067422_optionSelected_2163],
        });
        const act_1419464017721962_closeComponent_2166 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_1419464017721962_clickPreventStop_2165 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_closeComponent_2166,
            event: "click.prevent.stop",
            displayName: "closeComponent",
        });
        const evh_1419464017721962_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1419464017721962_clickPreventStop_2165],
        });
        return {
            act_7315092382398562_closeModal_2156,
            evh_7315092382398562_close_2155,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_2158,
            evh_2248226175642056_close_2157,
            evh_2248226175642056_close,
            act_1040167445267876_closeComponent_2162,
            evh_1040167445267876_success_2161,
            act_1040167445267876_request_2160,
            evh_1040167445267876_submit_2159,
            evh_1040167445267876_submit,
            act_814138253067422_script_2164,
            evh_814138253067422_optionSelected_2163,
            evh_814138253067422_optionSelected,
            act_1419464017721962_closeComponent_2166,
            evh_1419464017721962_clickPreventStop_2165,
            evh_1419464017721962_clickPreventStop,
            save: act_1040167445267876_request_2160,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Array,
    }),
    __metadata("design:type", typeof (_a = typeof array !== "undefined" && array) === "function" ? _a : Object)
], CopyBillingListItems.prototype, "sources", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('sources'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], CopyBillingListItems.prototype, "onSources", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "lg",
    }),
    __metadata("design:type", String)
], CopyBillingListItems.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], CopyBillingListItems.prototype, "onSize", null);
CopyBillingListItems = __decorate([
    (0, vue_property_decorator_1.Component)()
], CopyBillingListItems);
exports.default = CopyBillingListItems;
vue_property_decorator_1.Vue.component("CopyBillingListItems", CopyBillingListItems);
